<template>
  <v-icon v-if="checked" :size="size" class="align-middle" :class="checkmarkClass">mdi-check-circle</v-icon>
  <v-icon v-else :size="size" class="align-middle text-muted">mdi-circle</v-icon>
</template>

<script>
export default {
  name: 'ChecklistCheckmark',
  props: {
    checkmarkClass: String,
    checked: Boolean,
    size: String
  }
}
</script>

<style scoped>
</style>
